document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-faq-trigger").forEach(trigger => {
    trigger.addEventListener("click", function () {
      let sectionValue = this.getAttribute("data-section");
      let relatedElements = document.querySelectorAll(`.hc-answer-question[data-section='${sectionValue}']`);

      this.classList.toggle('hc-opened');
      relatedElements.forEach(element => {
        if (element.style.display === "none" || element.style.display === "") {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });
    });
  });
});

function scrollToAndClickDataQ() {
  if (!document.querySelector('.hc-template-faq')) return;

  let hash = decodeURIComponent(window.location.hash.substring(1));
  if (!hash) return;

  const [primary, secondary] = hash.split('?');

  const target = document.querySelector(`[data-q="${primary}"]`);
  if (!target) return;

  const scrollToWithOffset = (element) => {
    const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  scrollToWithOffset(target);

  setTimeout(() => {
    target.click();

    if (secondary) {
      const subTarget = document.querySelector(`[data-q-b="${secondary}"]`);
      if (subTarget) {
        setTimeout(() => {
          scrollToWithOffset(subTarget);
          setTimeout(() => {
            subTarget.click();
          }, 200);
        }, 400);
      }
    }
  }, 800);
}

window.addEventListener('DOMContentLoaded', scrollToAndClickDataQ);
window.addEventListener('hashchange', scrollToAndClickDataQ);
